import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-12 text-center wow fadeIn\" data-wow-delay=\"300ms\"><h2 class=\"heading bottom40 darkcolor font-light2\"><span class=\"font-normal\">Lupa Password</span><span class=\"divider-center\"></span></h2><div class=\"col-md-8 offset-md-2 heading_space\"><p></p></div></div>", 1)
const _hoisted_2 = { class: "col-lg-6 col-md-12 col-sm-12 pr-lg-0 whitebox noshadow" }
const _hoisted_3 = { class: "widget logincontainer" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "darkcolor bottom35 text-center text-md-left" }, " Masukkan Email Anda untuk Reset Password ", -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12 col-sm-12" }
const _hoisted_7 = { class: "form-group bottom35" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "registerEmail",
  class: "d-none"
}, null, -1)
const _hoisted_9 = { class: "col-md-12 col-sm-12" }
const _hoisted_10 = { class: "form-group bottom25 text-center" }
const _hoisted_11 = { class: "d-flex w-100 justify-content-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "button gradient-btn w-100"
  }, " Submit ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_RecaptchaV2 = _resolveComponent("RecaptchaV2")!
  const _component_Form = _resolveComponent("Form")!
  const _component_b_overlay = _resolveComponent("b-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_b_overlay, {
        show: _ctx.loadingCard,
        rounded: "sm"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_Form, {
              class: "getin_form border-form",
              id: "login",
              "validation-schema": _ctx.schema,
              onSubmit: _ctx.submitLogin
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createVNode(_component_Field, {
                        class: "form-control",
                        type: "email",
                        placeholder: "Email:",
                        name: "email",
                        style: {"margin":"0px !important"},
                        modelValue: _ctx.loginData.email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginData.email) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        class: "text-danger",
                        name: "email"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_RecaptchaV2, {
                          onWidgetId: _ctx.handleWidgetId,
                          onErrorCallback: _ctx.handleErrorCalback,
                          onExpiredCallback: _ctx.handleExpiredCallback,
                          onLoadCallback: _ctx.handleLoadCallback,
                          language: "id"
                        }, null, 8, ["onWidgetId", "onErrorCallback", "onExpiredCallback", "onLoadCallback"])
                      ])
                    ])
                  ]),
                  _hoisted_12
                ])
              ]),
              _: 1
            }, 8, ["validation-schema", "onSubmit"])
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}